<p-button styleClass="p-button-raised p-button-secondary p-button-text acctBtn" [style]="{'min-width': '100%','margin-bottom': '20px'}" (click)="redirectaccount()">
    <div class="row cbl"> 
        <i class="pi pi-user cfmr"></i>  <span>Cuenta </span>
        <div class="mt-15">Administre la información y la contraseña de su cuenta.</div>
    </div>
</p-button>
<br/><br/>

<p-button styleClass="p-button-raised p-button-secondary p-button-text devBtn" [style]="{'min-width': '100%','margin-bottom': '20px'}" (click)="redirectDevice()">
    <div class="row cbl"> 
        <i class="pi pi-comment cfmr"></i>  <span>Perfil de WhatsApp: Prueba </span>
        <div class="mt-15"> Administrar la información de la cuenta del perfil de WhatsApp.</div>
    </div>
</p-button>
<br/><br/>
<p-button styleClass="p-button-raised p-button-secondary p-button-text devBtn" [style]="{'min-width': '100%','margin-bottom': '20px'}" (click)="redirectDevice()">
    <div class="row cbl"> 
        <i class="pi pi-plus cfmr"></i>  <span>Notificaciones </span>
        <div class="mt-15">Administra cómo deseas ser notificado cuando usas el chat.</div>
    </div>
</p-button>

<br/><br/>
<p-button styleClass="p-button-raised p-button-secondary p-button-text devBtn" [style]="{'min-width': '100%','margin-bottom': '20px'}" (click)="redirectDevice()">
    <div class="row cbl" > 
        <i class="pi pi-phone cfmr"></i>  <span>Configuración de dispositivo </span>
        <div class="mt-15">Administre el estado, la configuración, las métricas y la facturación del dispositivo virtual.</div>
    </div>
</p-button>